import React from "react";
import { useTranslation } from "react-i18next";

import { Button } from "../Buttons";

import usersService from "../../../services/userService";

import "./footer.scss";
import { MainLogo } from "./../../../assets";

function Footer() {
  const { t } = useTranslation();
  return (
    <footer>
      <div className="infoBlock">
        <Button
          customClassName="footerLogoBtn"
          onClick={() => usersService.goToMonolith("")}
        >
          <img className="footerLogo" src={MainLogo} alt="Blue Manor Academy" />
        </Button>

        <div className="copyrightBlock">
          <p>
            2025 © <a href="/">Blue Manor Academy</a>
            <span>&nbsp;|&nbsp;</span>
          </p>
          <p>{t("rights")}</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
